<template>
  <div class="basketball_halfFeild_shootHotspot">
    <div
      class="echart_dom"
      ref="echartDom_home"
      :style="{ height: `${pHeight}px` }"
    ></div>
  </div>
</template>

<script>
// 上下布局 半场篮球投篮散点图 主题 (未开发完：坐标系不对，场地宽高比例待定)
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'basketball_halfFeild_shootHotspot',
  mixins: [canvasToImage_base64_data_mixin],
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        title: '',
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    iconArr: {
      type: Array,
      default: () => {
        return [
          'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAApVBMVEUAAAD29vn////////e3ub////19fj5+fv///+MjKmsrMGgoLnDw9P///+FhaSpqcD///////////////+pqb+bm7X6+vv5+fr39/r39/r29vj19fj29vn29vj///////////+NjaqWlrF7e53d3eaiorru7vK8vM3u7vLBwdHJydfi4un19fj///////////////////87O21PT3xDQ3P///9HR3YowbcNAAAAMnRSTlMAsXMT7gP28z/9+fjyLf76WTgBHP789u7p6Oisqp4qJQj9/Pz7+PPz8vLw77VgW1pTMJCKJxgAAADkSURBVCjPjdJps4IgFIBhDoIogprtt+3u+70Vav//p6VMYeqp6f36zGGAOeTOHgc7Sv8DjtBgJdi3TL7YBHR3avU5zo0tD/1f79KG5WthXEU02zS2mcamVVwO3dz0xXQaz84nL6Tp9bY83fPd9Cv8vcXls0F6WtTGJwcMc8HrU38MGgsq/PvAUaUV0gTHhNYob2CqcFTbCgN240Jc5NefQiDEMARSp/0C+z5tMYOojxFkxObNR12LH9wyeGXctlG5Jq71PGqtiZ1zeeCHzYKBtaZMg2BKSsUE6Iz04kFKaYosNd4RgK5WVQ9VjhcAAAAASUVORK5CYII=',
          'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJFBMVEX///////8AAAD///////////87O223t8lQUHy9vc7IyNa+vs5slglSAAAABnRSTlMIuwDni4UM6kzzAAAAWklEQVQI12NgNXZQUmIxDmCI6pjIpCDZsZTBIi1dgLEsrRnISCsUTwMyPNPS0svS0rYwMAJJIFuAQQEoDpRlYlACCgEFlOAMuBRcMVw73ECEFVEdG8GWwp0BAAZTJ220+cKkAAAAAElFTkSuQmCC',
        ] // [成功，失败]
      },
    },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      echartsArr: [],
      pHeight: 0,

      shootDataArr: [],
      allShootDataArr: [],
    }
  },
  watch: {
    datas(newVal, oldVal) {
      console.debug('watch datas:', newVal, oldVal)
      this.changeData(newVal)
    },
  },
  created() {
    console.debug(this.datas)
  },
  mounted() {
    this.$nextTick(() => {
      this.initDomWH()
      this.changeData(this.datas)
    })
  },
  beforeDestroy() {
    //性能优化，防止溢出
    this.echartsArr.forEach((val) => {
      val.echarts.dispose() //销毁echarts实例，防止内侧泄露
    })
    this.echartsArr = []
  },
  methods: {
    initDomWH() {
      const echartsBoxDom = this.$refs.echartDom_home
      console.debug('echartDom_home:', echartsBoxDom.clientWidth)
      this.pWidth = echartsBoxDom.clientWidth

      this.pHeight = Math.ceil(this.pWidth * 0.93)
      console.debug('this.pWidth:', this.pWidth, this.pHeight)
    },
    changeData(datas) {
      // 开启渲染数据逻辑
      if (datas && datas.data.dataList) {
        // dataList=[]；说明数据为空，也要渲染
        setTimeout(() => {
          this.filterHotSopt(datas.data.dataList)
        }, 10)
      }
    },
    filterHotSopt(data) {
      var shootDataArr =
        data && data.length > 0
          ? data.map((val) => {
              var symbol = null
              if (val.fgTypeStatus) {
                symbol = this.iconArr[0]
              } else {
                symbol = this.iconArr[1]
              }
              return {
                value: [val.pointX, val.pointY], //坐标
                symbol: symbol, //图标（主客队&是否投正）
                symbolSize: val.fgTypeStatus ? 12 : 12, //投歪：8；投正：12
                playerName: val.playerName ? val.playerName : '', //球员名字
                isShoot: val.fgTypeStatus, //是否投正
              }
            })
          : []
      console.debug('last:', shootDataArr)
      this.shootDataArr = shootDataArr
      this.shootHotspotEcharts(this.$refs.echartDom_home)
    },
    shootHotspotEcharts(ref) {
      let Echart = this.$echarts
      if (this.echartsArr.length) {
        var result = this.echartsArr.some(function (val) {
          if (val.name === 'basketball_halfFeild_shootHotspot') {
            return true
          }
        })
        if (!result) {
          this.echartsArr.push({
            name: 'basketball_halfFeild_shootHotspot',
            refs: ref,
            echarts: Echart.init(ref),
          })
        }
      } else {
        this.echartsArr.push({
          name: 'basketball_halfFeild_shootHotspot',
          refs: ref,
          echarts: Echart.init(ref),
        })
      }
      // old 之前
      // var rateNum_x = (48.6 / 50) * 2
      // var rateNum_y = 47.4 / 50 //(1.4, 2.6) (48.6, 47.4) (98.6, 97.4)
      // // [0,0]左下角； [0.5,0.5]中心； [1,1]右上角；
      // var shootDataArr = [].concat(this.shootDataArr)
      // shootDataArr.forEach((val) => {
      //   //  console.debug(val.value)
      //   if (val.value.length === 2) {
      //     val.value[0] =
      //       Math.round(val.value[0] * 100 * rateNum_x * 100) / 100 + 1.4
      //     val.value[1] =
      //       Math.round(val.value[1] * 100 * rateNum_y * 100) / 100 + 2.6
      //   } else {
      //     val.value = [150, 150]
      //   }
      // })

      var rateNum_x = 48.6 / 50
      var rateNum_y = 48.8 / 50 //(1.4, 2.6) (48.6, 47.4) (98.6, 97.4)
      // [0,0]右下角； [0.5,0.5]中心； [1,1]左上角；
      var shootDataArr = [].concat(this.shootDataArr)
      shootDataArr.forEach((val) => {
        //  console.debug(val.value)
        if (val.value.length === 2) {
          val.value[0] =
            Math.round(val.value[0] * 100 * rateNum_x * 100) / 100 + 1.4
          val.value[1] =
            Math.round(val.value[1] * 100 * rateNum_y * 100) / 100 + 1.2
        } else {
          val.value = [150, 150]
        }
      })

      var option = {
        grid: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        },
        tooltip: {
          show: true,
          // position: function (point, params, dom, rect, size) {
          //   // 固定在顶部
          //   var x = 150,
          //     y = 150,
          //     d = 2

          //   if (params.data.value[0] > 50) {
          //     x = params.data.value[0] - 12
          //   } else if (params.data.value[0] == 50) {
          //     x = params.data.value[0]
          //   } else {
          //     x = params.data.value[0] + d
          //   }
          //   if (100 - params.data.value[1] > 50) {
          //     y = 100 - params.data.value[1] - 12
          //   } else if (100 - params.data.value[1] == 50) {
          //     y = 100 - params.data.value[1] + 4
          //   } else {
          //     y = 100 - params.data.value[1] + d
          //   }
          //   //  console.debug(x, y)
          //   return [x + '%', y + '%']
          // },
          formatter: function (params) {
            //  console.debug(params)
            var tipName = '球员：' + params.data.playerName
            var tipState = params.data.isShoot ? '投篮：命中' : '投篮：未命中'
            //  console.debug(tipName+tipState)
            return tipName + '<br />' + tipState
          },
        },
        xAxis: {
          show: false,
          max: 100,
          min: 0,
        },
        yAxis: {
          show: false,
          max: 100,
          min: 0,
          inverse: true,
        },
        series: [
          {
            type: 'scatter',
            // symbolSize: 20,
            data: shootDataArr,
          },
        ],
      }
      // 使用刚指定的配置项和数据显示图表。
      this.echartsArr.forEach(function (val, index) {
        if (val.name === 'basketball_halfFeild_shootHotspot') {
          val.echarts.setOption(option)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.basketball_halfFeild_shootHotspot {
  position: relative;
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  .echart_dom {
    width: 100%;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-image: var(--mixtmt_halfField_ver_bg);
  }
}
</style>
